import { saveAs } from 'file-saver';
export default saveAs;
